import React from "react";
import { EyeOutlined, DownloadOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import { FilesCell } from "./FilesCell";
import { PaymentCell } from "./PaymentCell";
import { ActionsCell } from "./ActionsCell";
import { CoverWizardModalPayload } from "../OrderContextMenu/CoverWizardModal/CoverWizardModal";
import OrderDto from "../../../store/actions/dtos/OrderDto";

interface BuildOrderColumnsDeps {
  fileLoading: boolean;
  fileSelectedSoNo: string | undefined;
  onOpenFileModal: (file: any) => void;
  paymentLoading: boolean;
  paymentSelectedSoNo: string | undefined;
  onShowPayment: (order: any) => void;
  isAuthenticated: boolean;
  isAdmin: boolean;
  cloneOrderButton: boolean;
  coverWizardModalPayloadState: [
    CoverWizardModalPayload | null,
    React.Dispatch<React.SetStateAction<CoverWizardModalPayload | null>>,
  ];
  editAttachmentsModalPayloadState: [
    OrderDto | null,
    React.Dispatch<React.SetStateAction<OrderDto | null>>,
  ];
  onReloadOrders: () => void;
}

export function buildOrderColumns({
  fileLoading,
  fileSelectedSoNo,
  onOpenFileModal,
  paymentLoading,
  paymentSelectedSoNo,
  onShowPayment,
  isAuthenticated,
  isAdmin,
  cloneOrderButton,
  coverWizardModalPayloadState,
  editAttachmentsModalPayloadState,
  onReloadOrders,
}: BuildOrderColumnsDeps) {
  return [
    { title: "SO#", dataIndex: "soNo", sorter: true },
    { title: "PO#", dataIndex: "poNo", sorter: true },
    { title: "Meyco#", dataIndex: "meycoNo", sorter: true },
    { title: "Job Name", dataIndex: "jobName", sorter: true },
    { title: "Order Date", dataIndex: "orderDate", sorter: true },
    { title: "Est Ship Date", dataIndex: "shippingDate", sorter: true },
    {
      title: "Order Status",
      dataIndex: "orderDescription",
      sorter: true,
      key: "orderDescription",
      render: (orderDescription: any) => (
        <span
          title={orderDescription}
          style={{
            maxWidth: "100px",
            wordWrap: "break-word",
            whiteSpace: "normal",
            display: "inline-block",
          }}
        >
          {orderDescription}
        </span>
      ),
    },
    {
      title: "Files",
      dataIndex: "file",
      render: (file: any) => (
        <div onClick={(e) => e.stopPropagation()}>
          <FilesCell
            file={file}
            fileLoading={fileLoading}
            selectedSoNo={fileSelectedSoNo}
            onOpen={onOpenFileModal}
          />
        </div>
      ),
    },
    {
      title: !isAuthenticated ? "" : isAdmin ? "Payment Status" : "Action",
      dataIndex: "customer",
      render: (customer: any) => (
        <div onClick={(e) => e.stopPropagation()}>
          <PaymentCell
            customer={customer}
            isAuthenticated={isAuthenticated}
            isAdmin={isAdmin}
            paymentLoading={paymentLoading}
            selectedSoNo={paymentSelectedSoNo}
            onShowPayment={onShowPayment}
          />
        </div>
      ),
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (_: any, row: any) => (
        <div onClick={(e) => e.stopPropagation()}>
          <ActionsCell
            row={row}
            cloneOrderButton={cloneOrderButton}
            coverWizardModalPayloadState={coverWizardModalPayloadState}
            editAttachmentsModalPayloadState={editAttachmentsModalPayloadState}
            onReloadOrders={onReloadOrders}
          />
        </div>
      ),
    },
    { title: "Tracking", dataIndex: "tracking" },
  ];
}

export function buildFileColumns(
  fileLoading: boolean,
  downloadLoading: boolean,
  onView: (file: any) => void,
  onDownload: (file: any) => void
) {
  return [
    { title: "SN", dataIndex: "sn" },
    { title: "File Name", dataIndex: "fileName" },
    { title: "Description", dataIndex: "description" },
    {
      title: "Action",
      dataIndex: "file",
      render: (file: any) => (
        <div className="action__btn__wrapper">
          <Tooltip placement="top" title="View">
            <Button
              loading={fileLoading}
              type="default"
              icon={<EyeOutlined />}
              onClick={() => onView(file)}
            />
          </Tooltip>
          <Tooltip placement="top" title="Download">
            <Button
              loading={downloadLoading}
              type="primary"
              icon={<DownloadOutlined />}
              onClick={() => onDownload(file)}
            />
          </Tooltip>
        </div>
      ),
    },
  ];
}
